export const EventType = Object.freeze({
	popup:
		{
			enable: 'BX:Sale:StoreMaster:EventType:popup:enable',
			enableWithoutReset: 'BX:Sale:StoreMaster:EventType:popup:enableWithoutReset',
			enableWithResetDocuments: 'BX:Sale:StoreMaster:EventType:popup:enableWithResetDocuments',
			disable: 'BX:Sale:StoreMaster:EventType:popup:disable',
			disableCancel: 'BX:Sale:StoreMaster:EventType:popup:disable:cancel',
			confirm: 'BX:Sale:StoreMaster:EventType:popup:confirm',
			confirmCancel: 'BX:Sale:StoreMaster:EventType:popup:confirm:cancel',
		},
});
